import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateUser = () => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    phoneNumber: '',
    homeAddress: '',
    university: '',
    enrollmentYear: '',
    enrollmentMonth: '',
    graduationYear: '',
    graduationMonth: '',
    referralCode: '',
    userType: 'student ambassador',
  });

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);
  const monthOptions = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const token = localStorage.getItem('accessToken');
    await axios.post(`${API_BASE_URL}/admin/create-user`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    toast.success('User created successfully!');

    // Reset the form
    setFormData({
      email: '',
      fullName: '',
      phoneNumber: '',
      homeAddress: '',
      university: '',
      enrollmentYear: '',
      enrollmentMonth: '',
      graduationYear: '',
      graduationMonth: '',
      referralCode: '',
      userType: 'student ambassador',
    });

  } catch (err) {
    console.error(err);
    toast.error('Failed to create user');
  }
};


  const fieldPairs = [
    [['email', 'Email'], ['fullName', 'Full Name']],
    [['phoneNumber', 'Phone Number'], ['homeAddress', 'Home Address']],
    [['university', 'University'], ['referralCode', 'Referral Code']],
  ];

  return (
    <div className="container">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    

      <form onSubmit={handleSubmit}>
        {fieldPairs.map((pair, idx) => (
          <div className="row" key={idx}>
            {pair.map(([name, label]) => (
              <div className="col-md-6 mb-3" key={name}>
                <label htmlFor={name} className="form-label">{label}</label>
                <input
                  type="text"
                  name={name}
                  id={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>
            ))}
          </div>
        ))}

        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="enrollmentYear" className="form-label">Enrollment Year</label>
            <select
              name="enrollmentYear"
              id="enrollmentYear"
              value={formData.enrollmentYear}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Year</option>
              {yearOptions.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="enrollmentMonth" className="form-label">Enrollment Month</label>
            <select
              name="enrollmentMonth"
              id="enrollmentMonth"
              value={formData.enrollmentMonth}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Month</option>
              {monthOptions.map(month => (
                <option key={month} value={month}>{month}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="graduationYear" className="form-label">Graduation Year</label>
            <select
              name="graduationYear"
              id="graduationYear"
              value={formData.graduationYear}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Year</option>
              {yearOptions.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="graduationMonth" className="form-label">Graduation Month</label>
            <select
              name="graduationMonth"
              id="graduationMonth"
              value={formData.graduationMonth}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Month</option>
              {monthOptions.map(month => (
                <option key={month} value={month}>{month}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 mb-3">
            <label htmlFor="userType" className="form-label">User Type</label>
            <select
              name="userType"
              id="userType"
              value={formData.userType}
              onChange={handleChange}
              className="form-control"
            >
              <option value="student ambassador">Student Ambassador</option>
              <option value="admin">Admin</option>
              <option value="student">Student</option>
            </select>
          </div>
        </div>

        <button type="submit" className="btn btn-primary">Create User</button>
      </form>
    </div>
  );
};

export default CreateUser;
